import { useTranslation } from "react-i18next";
import { PaletteDetail } from "@/components/customCotations/detailModal/paletteDetail";
import { ParcelDetail } from "@/components/customCotations/detailModal/parcelDetail";
import { CustomQuotationTypeEnum } from "@/constants/enums/customQuotationType.enum";
import { GetOneExpeditionBoResponseDto } from "@/types/api/api-types";

import { SectionTitle } from "./sectionTitle";

type CustomCotationsInfoProps = {
  expedition: GetOneExpeditionBoResponseDto;
};

const renderDetail = (expedition: GetOneExpeditionBoResponseDto) => {
  switch (expedition.customQuotation?.type) {
    case CustomQuotationTypeEnum.PALETTE:
      return <PaletteDetail expedition={expedition} />;
    case CustomQuotationTypeEnum.PARCEL:
      return <ParcelDetail expedition={expedition} />;
    default:
      return null;
  }
};

export const CustomCotationsInfo = ({ expedition }: CustomCotationsInfoProps) => {
  const { t } = useTranslation("boLogistics");
  const detail = renderDetail(expedition);
  if (!detail) return null;

  return (
    <div className="flex flex-col gap-2">
      <SectionTitle>{t("pickupDetailsCustomQuotation.title")}</SectionTitle>
      <div className="flex w-full flex-col bg-white md:w-[460px]">{detail}</div>
    </div>
  );
};
